import { render, staticRenderFns } from "./SummaryPnpQuestion.vue?vue&type=template&id=fb743a18"
import script from "./SummaryPnpQuestion.vue?vue&type=script&lang=js"
export * from "./SummaryPnpQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports